import React from 'react';
import { useSelector } from 'react-redux';
import { stateIsLoaded } from '@guryou/redux';
import BookSection from './bookSection';
import CTASection from './ctaSection';
import HeroSection from './heroSection';
import ReservationsCalendar from './reservationsCalendar';
// import ReadSection from './readSection';
import SelectSection from './selectSection';

const HomePage = () => {
  const auth = useSelector(state => state.auth);

  // Se usuário estiver logado, mostrar calendário de reservas
  if (stateIsLoaded(auth) && auth?.data?.userId) {
    return (
      <div className="bg-gray-50 w-full h-full overflow-hidden flex flex-col">
        <ReservationsCalendar />
      </div>
    );
  }

  // Se não estiver logado, mostrar home page tradicional
  return (
    <>
      <HeroSection />
      <BookSection />
      {/* <ReadSection /> */}
      <SelectSection />
      <CTASection />
    </>
  );
};
export default HomePage;
